'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var BlockSelect_module = require('../BlockSelect.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

const getBgClass = (active, selected, hovered) => {
  if (selected && hovered) return BlockSelect_module["default"].deepskyblue;
  if (selected && active) return BlockSelect_module["default"].deepskyblue;
  if (hovered) return BlockSelect_module["default"].ghostwhite;
  if (selected) return BlockSelect_module["default"].lightblue;
  if (active) return BlockSelect_module["default"].whitesmoke;
  return BlockSelect_module["default"].transparent;
};
const Option = ({
  id,
  option,
  selected,
  active,
  onClick
}) => {
  const [hovered, setHovered] = React.useState(false);
  const optionRef = React.useRef(null);
  const handleClick = () => {
    onClick(option);
  };
  const handleMouseEnter = () => {
    setHovered(true);
  };
  const handleMouseLeave = () => {
    setHovered(false);
  };
  const isSelected = selected?.value === option.value;
  const classes = clsx__default["default"]({
    [getBgClass(active, isSelected, hovered)]: true,
    [BlockSelect_module["default"].option]: true
  });
  return /*#__PURE__*/ /* eslint-disable-next-line eslint-comments/disable-enable-pair */ /* eslint-disable jsx-a11y/click-events-have-key-events */React__default["default"].createElement("li", {
    id: id,
    className: classes,
    ref: optionRef,
    role: "option",
    "aria-selected": option.value === selected?.value,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, option.label);
};

exports.Option = Option;
